import { createContext, useMemo, useState } from 'react';
import { setAuthToken } from '../services/apiClient';
import type { AuthState, AuthUser, UserRole } from '../types/auth';

export interface AuthContextValue extends AuthState {
  loginAsRole: (role: UserRole) => void;
  logout: () => void;
}

const roleToUser = (role: UserRole): AuthUser => {
  return {
    id: `demo-${role}`,
    email: `${role}@ouclub.local`,
    role,
    displayName: `Demo ${role.replace('_', ' ')}`,
  };
};

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<AuthUser | null>(null);

  const value = useMemo<AuthContextValue>(() => {
    return {
      isAuthenticated: Boolean(user),
      user,
      loginAsRole: (role) => {
        const nextUser = roleToUser(role);
        setUser(nextUser);
        setAuthToken(`demo-token-${role}`);
      },
      logout: () => {
        setUser(null);
        setAuthToken(null);
      },
    };
  }, [user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
